import React, { Component } from 'react';
import client from './../../utils/apolloClient';
import getData from './../../data-services/api';
import { getUser } from './../../data-services/queries';
import gql from 'graphql-tag';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Select from '@material-ui/core/Select';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import IconButton from '@material-ui/core/IconButton';
import './Fevicryl.css';
import Loader from './../../components/CustomLoader';
import { IoArrowForwardCircleOutline } from 'react-icons/io5';
import { VscSettings } from 'react-icons/vsc';
import { TbFilter } from 'react-icons/tb';
import { IoSearchSharp } from 'react-icons/io5';
import { connect } from 'react-redux';
import { setFevicyrlContent } from '../../redux/actions/actions';

export class FevicyrlContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            FCCAll: [],
            FCC: [],
            SEASONALITY: [],
            CRAFT_CATEGORY: [],
            TIME_PERIOD: [],
            DIFFICULTY: [],
            YEARS: [],
            searchTerm: '',
            fevicyrl: {
                seasonality__c: '',
                craft_category__c: '',
                is_best_out_of_waste__c: '',
                hero_product_2__c: '',
                hero_product_1__c: '',
                festival_generic__c: '',
                art_form__c: '',
                difficulty_level__c: '',
                institute__c: '',
                year__c: '',
            },
        };
    }

    async componentDidMount() {
        await client
            .query({
                query: gql(getUser),
            })
            .then(({ data }) => {
                if (data.user.role === 'CMDI' || data.user.role === 'AMMD') {
                    this.setState({
                        userData: data.user,
                    });
                }
            });

        let FCCAllResult;
        const { setFevicyrlContent, fevicyrlContent } = this.props;

        if (fevicyrlContent && fevicyrlContent.length > 0) {
            this.prepareDropdowns(fevicyrlContent);
            this.setState({
                FCCAll: fevicyrlContent,
                FCC: fevicyrlContent,
                loading: false,
            });
        }

        FCCAllResult = await getData(
            `select id,sfid,art_form__c,activity__c,article_category__c,article_sub_category__c, Craft_Category__c, In_House_Products_Used__c, Level_Of_Difficulty__c, Link_In_Pil_Tantra__c,thumbnail_link__c, Name,Year__c,
                Non_Pil_Product_Price__c, Out_Sourced_Products_Use__c, Pil_Product_Price__c,hero_product_2__c,hero_product_1__c,revised_technique__c,is_best_out_of_waste__c, Seasonality__c, Time_Period__c,Thumbnail_URL__c,
                festival_generic__c,difficulty_level__c,institute__c, Total_Cost_of_making_the_article__c, Link_In_Pil_Tantra_URL__c from Salesforce.Content_Categorization__c where Active__c = true `
        );
        setFevicyrlContent(FCCAllResult.result);
    }

    // You can keep your helpers as class methods for convenience:
    getUniqueListBy = (arr, keys) => {
        if (!Array.isArray(arr) || arr.length === 0) return [];
        const uniqueMap = new Map();
        arr.forEach((item) => {
            if (
                keys.every(
                    (key) =>
                        item[key] !== null &&
                        item[key] !== undefined &&
                        item[key].trim() !== '' &&
                        item[key] !== 'NA'
                )
            ) {
                const uniqueKey = keys.map((key) => item[key]).join('|');
                if (!uniqueMap.has(uniqueKey)) uniqueMap.set(uniqueKey, item);
            }
        });
        return [...uniqueMap.values()].sort((a, b) =>
            keys
                .map((key) => a[key])
                .join('|')
                .localeCompare(keys.map((key) => b[key]).join('|'))
        );
    };

    getUniqueValuesByKeys = (data, keys) => {
        if (!Array.isArray(data) || data.length === 0) return [];
        const valuesSet = new Set();
        data.forEach((item) => {
            keys.forEach((key) => {
                const value = item[key];
                if (
                    value !== null &&
                    value !== undefined &&
                    value.trim() !== '' &&
                    value !== 'NA'
                ) {
                    valuesSet.add(value);
                }
            });
        });
        return Array.from(valuesSet).sort((a, b) => a.localeCompare(b));
    };

    componentDidUpdate(prevProps) {
        if (
            prevProps.fevicyrlContent !== this.props.fevicyrlContent &&
            Array.isArray(this.props.fevicyrlContent) &&
            this.props.fevicyrlContent.length > 0
        ) {
            this.prepareDropdowns(this.props.fevicyrlContent);

            this.setState({
                FCCAll: this.props.fevicyrlContent,
                FCC: this.props.fevicyrlContent,
                loading: false,
            });
        }
    }

    prepareDropdowns = (FCCAll) => {
        const SEASONALITY = this.getUniqueListBy(FCCAll, ['seasonality__c']);
        const CRAFT_CATEGORY = this.getUniqueListBy(FCCAll, ['craft_category__c']);
        const TIME_PERIOD = this.getUniqueListBy(FCCAll, ['time_period__c']);
        const DIFFICULTY = this.getUniqueListBy(FCCAll, ['difficulty_level__c']);
        const INSTITUTE = this.getUniqueListBy(FCCAll, ['institute__c']);
        const ART_FORM = this.getUniqueListBy(FCCAll, ['art_form__c']);
        const FESTIVALGENERIC = this.getUniqueListBy(FCCAll, ['festival_generic__c']);
        const BESTOUTOFWASTE = this.getUniqueListBy(FCCAll, ['is_best_out_of_waste__c']);
        const PRODUCT = this.getUniqueValuesByKeys(FCCAll, [
            'hero_product_1__c',
            'hero_product_2__c',
        ]);
        const YEARS = this.getUniqueListBy(FCCAll, ['year__c']);

        this.setState({
            FCCAll,
            FCC: FCCAll,
            loading: false,
            SEASONALITY,
            CRAFT_CATEGORY,
            TIME_PERIOD,
            DIFFICULTY,
            INSTITUTE,
            ART_FORM,
            FESTIVALGENERIC,
            BESTOUTOFWASTE,
            PRODUCT,
            YEARS,
        });
    };

    createDynamicObject = (field, value) => {
        const fields = [
            'seasonality__c',
            'craft_category__c',
            'time_period__c',
            'difficulty_level__c',
            'institute__c',
            'art_form__c',
            'festival_generic__c',
            'is_best_out_of_waste__c',
            'hero_product_1__c',
            'hero_product_2__c',
            'year__c',
        ];

        return fields.reduce((obj, key) => {
            if (key === field) {
                obj[key] = value; // Set the selected field's value
            }
            return obj;
        }, {});
    };

    handleChange = (e) => {
        const { name, value } = e.target;

        // Update the selected field in `fevicyrl` while keeping others intact
        const updatedFevicyrl = {
            ...this.state.fevicyrl,
            [name]: value,
        };

        // Filter data dynamically
        let filteredFCC = this.state.FCCAll.filter((item) => {
            return Object.keys(updatedFevicyrl).every((key) => {
                // Handle hero_product_1__c special case
                if (key === 'hero_product_1__c' && updatedFevicyrl.hero_product_1__c) {
                    return (
                        item.hero_product_1__c === updatedFevicyrl.hero_product_1__c ||
                        item.hero_product_2__c === updatedFevicyrl.hero_product_1__c
                    );
                }
                // General filter for other fields
                return !updatedFevicyrl[key] || item[key] === updatedFevicyrl[key];
            });
        });

        // Update state
        this.setState({
            fevicyrl: updatedFevicyrl,
            FCC: filteredFCC,
        });
    };

    handleInputChange = (e) => {
        var value = e.target.value.toUpperCase();
        this.setState({
            searchTerm: value,
        });
    };

    handleSearch = () => {
        // onSearch(searchTerm);
    };

    gotoWorkshop = (item) => {
        this.props.history.push({
            pathname: '/fevicryl-Details',
            productData: item,
        });
    };

    render() {
        const {
            fevicyrl,
            FCC,
            DIFFICULTY,
            YEARS,
            INSTITUTE,
            ART_FORM,
            FESTIVALGENERIC,
            BESTOUTOFWASTE,
            PRODUCT,
            loading,
            searchTerm,
        } = this.state;
        const { history } = this.props;

        return (
            <>
                <AppBar position="static">
                    <Toolbar>
                        <Grid item xs={2} sm={2} md={2}>
                            <IconButton
                                color="inherit"
                                aria-label="Menu"
                                onClick={() => {
                                    history.goBack();
                                }}
                            >
                                <ArrowBackIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={8} sm={8} md={8}>
                            <Typography variant="title" color="inherit" className="text-center">
                                Fevicryl Content Categorization
                            </Typography>
                        </Grid>
                    </Toolbar>
                </AppBar>
                {loading ? (
                    <Grid container alignItems="center" justify="center">
                        <Loader type="Audio" color="#00BFFF" height="50" width="50" />
                    </Grid>
                ) : (
                    <>
                        <div className="d-none d-md-block">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-3">
                                        <div className="fevicyrlContent__selectBox">
                                            <Select
                                                native
                                                name="hero_product_1__c"
                                                value={fevicyrl.hero_product_1__c} // You can dynamically set this value
                                                onChange={this.handleChange}
                                                className="fevicyrlContent__fevicyrlFilters"
                                            >
                                                <option value="" disabled hidden>
                                                    SELECT PRODUCT
                                                </option>
                                                <option
                                                    value=""
                                                    className="fevicyrlContent__filterLabel"
                                                >
                                                    Remove Filter
                                                </option>
                                                {PRODUCT &&
                                                    PRODUCT.map((item, index) => (
                                                        <option
                                                            key={`product-${index}`} // Unique key for React
                                                            value={item}
                                                            className="fevicyrlContent__filterLabel"
                                                        >
                                                            {item}
                                                        </option>
                                                    ))}
                                            </Select>
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <div className="fevicyrlContent__selectBox">
                                            <Select
                                                native
                                                name="difficulty_level__c"
                                                value={fevicyrl.difficulty_level__c}
                                                onChange={this.handleChange}
                                                className="fevicyrlContent__fevicyrlFilters"
                                            >
                                                <option value="" disabled hidden>
                                                    DIFFICULTY LEVEL
                                                </option>
                                                <option
                                                    value=""
                                                    className="fevicyrlContent__filterLabel"
                                                >
                                                    Remove Filter
                                                </option>
                                                {DIFFICULTY &&
                                                    DIFFICULTY.map((item) => {
                                                        return (
                                                            <>
                                                                <option
                                                                    value={item.difficulty_level__c}
                                                                    className="fevicyrlContent__filterLabel"
                                                                >
                                                                    {item.difficulty_level__c}
                                                                </option>
                                                            </>
                                                        );
                                                    })}
                                            </Select>
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <div className="fevicyrlContent__selectBox">
                                            <Select
                                                native
                                                name="institute__c"
                                                value={fevicyrl.institute__c}
                                                onChange={this.handleChange}
                                                className="fevicyrlContent__fevicyrlFilters"
                                            >
                                                <option value="" disabled hidden>
                                                    INSTITUTE
                                                </option>
                                                <option
                                                    value=""
                                                    className="fevicyrlContent__filterLabel"
                                                >
                                                    Remove Filter
                                                </option>
                                                {INSTITUTE &&
                                                    INSTITUTE.map((item) => {
                                                        return (
                                                            <>
                                                                <option
                                                                    value={item.institute__c}
                                                                    className="fevicyrlContent__filterLabel"
                                                                >
                                                                    {item.institute__c}
                                                                </option>
                                                            </>
                                                        );
                                                    })}
                                            </Select>
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <div className="fevicyrlContent__selectBox">
                                            <Select
                                                native
                                                name="art_form__c"
                                                value={fevicyrl.art_form__c}
                                                onChange={this.handleChange}
                                                className="fevicyrlContent__fevicyrlFilters"
                                            >
                                                <option value="" disabled hidden>
                                                    ART FORM
                                                </option>
                                                <option
                                                    value=""
                                                    className="fevicyrlContent__filterLabel"
                                                >
                                                    Remove Filter
                                                </option>
                                                {ART_FORM &&
                                                    ART_FORM.map((item) => {
                                                        return (
                                                            <>
                                                                <option
                                                                    value={item.art_form__c}
                                                                    className="fevicyrlContent__filterLabel"
                                                                >
                                                                    {item.art_form__c}
                                                                </option>
                                                            </>
                                                        );
                                                    })}
                                            </Select>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-3">
                                        <div className="fevicyrlContent__selectBox">
                                            <Select
                                                native
                                                name="festival_generic__c"
                                                value={fevicyrl.festival_generic__c}
                                                onChange={this.handleChange}
                                                className="fevicyrlContent__fevicyrlFilters"
                                            >
                                                <option value="" disabled hidden>
                                                    FESTIVAL / GENERIC
                                                </option>
                                                <option
                                                    value=""
                                                    className="fevicyrlContent__filterLabel"
                                                >
                                                    Remove Filter
                                                </option>
                                                {FESTIVALGENERIC &&
                                                    FESTIVALGENERIC.map((item) => {
                                                        return (
                                                            <>
                                                                <option
                                                                    value={item.festival_generic__c}
                                                                    className="fevicyrlContent__filterLabel"
                                                                >
                                                                    {item.festival_generic__c}
                                                                </option>
                                                            </>
                                                        );
                                                    })}
                                            </Select>
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <div className="fevicyrlContent__selectBox">
                                            <Select
                                                native
                                                name="is_best_out_of_waste__c"
                                                value={fevicyrl.is_best_out_of_waste__c}
                                                onChange={this.handleChange}
                                                className="fevicyrlContent__fevicyrlFilters"
                                            >
                                                <option value="" disabled hidden>
                                                    BEST OUT OF WASTE
                                                </option>
                                                <option
                                                    value=""
                                                    className="fevicyrlContent__filterLabel"
                                                >
                                                    Remove Filter
                                                </option>
                                                {BESTOUTOFWASTE &&
                                                    BESTOUTOFWASTE.map((item) => {
                                                        return (
                                                            <>
                                                                <option
                                                                    value={
                                                                        item.is_best_out_of_waste__c
                                                                    }
                                                                    className="fevicyrlContent__filterLabel"
                                                                >
                                                                    {item.is_best_out_of_waste__c}
                                                                </option>
                                                            </>
                                                        );
                                                    })}
                                            </Select>
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <div className="fevicyrlContent__selectBox">
                                            <Select
                                                native
                                                name="year__c"
                                                value={fevicyrl.year__c}
                                                onChange={this.handleChange}
                                                className="fevicyrlContent__fevicyrlFilters"
                                            >
                                                <option value="" disabled hidden>
                                                    YEARS
                                                </option>
                                                <option
                                                    value=""
                                                    className="fevicyrlContent__filterLabel"
                                                >
                                                    Remove Filter
                                                </option>
                                                {YEARS &&
                                                    YEARS.map((item) => {
                                                        return (
                                                            <>
                                                                <option
                                                                    value={item.year__c}
                                                                    className="fevicyrlContent__filterLabel"
                                                                >
                                                                    {item.year__c}
                                                                </option>
                                                            </>
                                                        );
                                                    })}
                                            </Select>
                                        </div>
                                    </div>
                                    <div className="col-3"></div>
                                </div>
                            </div>
                        </div>

                        <div className="d-block d-md-none">
                            <div className="d-flex mt-3">
                                <div className="fevicyrlContent__search_bar">
                                    <input
                                        type="text"
                                        placeholder="Search User"
                                        // value={searchTerm}
                                        onChange={this.handleInputChange}
                                        className="fevicyrlContent__searchInput w-100"
                                    />
                                    <button
                                        onClick={this.handleSearch}
                                        className="fevicyrlContent__searchButton"
                                    >
                                        <IoSearchSharp className="fevicyrlContent__searchButtonIcon" />
                                    </button>
                                </div>
                                <div className="fevicyrlContent__settingBox">
                                    <button>
                                        <VscSettings className="fevicyrlContent__settingIcon" />
                                    </button>
                                </div>

                                <div className="dropdown fevicyrlContent__dropDownFilter">
                                    <button
                                        class="btn btn-secondary dropdown-toggle"
                                        type="button"
                                        id="dropdownMenuButton1"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                    >
                                        <TbFilter className="fevicyrlContent__filterIcon" />
                                    </button>
                                    <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                        <li>
                                            <div className="fevicyrlContent__selectMobBox">
                                                <Select
                                                    native
                                                    name="hero_product_1__c"
                                                    value={fevicyrl.hero_product_1__c} // You can dynamically set this value
                                                    onChange={this.handleChange}
                                                    className="fevicyrlContent__fevicyrlMobFilters"
                                                >
                                                    <option value="">SELECT PRODUCT</option>
                                                    <option
                                                        value=""
                                                        className="fevicyrlContent__filterLabel"
                                                    >
                                                        Remove Filter
                                                    </option>
                                                    {PRODUCT &&
                                                        PRODUCT.map((item, index) => (
                                                            <option
                                                                key={`product-${index}`} // Unique key for React
                                                                value={item}
                                                                className="fevicyrlContent__filterLabel"
                                                            >
                                                                {item}
                                                            </option>
                                                        ))}
                                                </Select>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="fevicyrlContent__selectMobBox">
                                                <Select
                                                    native
                                                    name="level_of_difficulty__c"
                                                    value={fevicyrl.level_of_difficulty__c}
                                                    onChange={this.handleChange}
                                                    className="fevicyrlContent__fevicyrlMobFilters"
                                                >
                                                    <option value="">DIFFICULTY LEVEL</option>
                                                    <option
                                                        value=""
                                                        className="fevicyrlContent__filterLabel"
                                                    >
                                                        Remove Filter
                                                    </option>
                                                    {DIFFICULTY &&
                                                        DIFFICULTY.map((item) => {
                                                            return (
                                                                <>
                                                                    <option
                                                                        value={
                                                                            item.level_of_difficulty__c
                                                                        }
                                                                        className="fevicyrlContent__filterLabel"
                                                                    >
                                                                        {
                                                                            item.level_of_difficulty__c
                                                                        }
                                                                    </option>
                                                                </>
                                                            );
                                                        })}
                                                </Select>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="fevicyrlContent__selectMobBox">
                                                <Select
                                                    native
                                                    name="institute__c"
                                                    onChange={this.handleChange}
                                                    className="fevicyrlContent__fevicyrlMobFilters"
                                                >
                                                    <option>INSTITUTE</option>
                                                    <option
                                                        value=""
                                                        className="fevicyrlContent__filterLabel"
                                                    >
                                                        Remove Filter
                                                    </option>
                                                    {INSTITUTE &&
                                                        INSTITUTE.map((item) => {
                                                            return (
                                                                <>
                                                                    <option
                                                                        value={item.institute__c}
                                                                        className="fevicyrlContent__filterLabel"
                                                                    >
                                                                        {item.institute__c}
                                                                    </option>
                                                                </>
                                                            );
                                                        })}
                                                </Select>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="fevicyrlContent__selectMobBox">
                                                <Select
                                                    native
                                                    name="art_form__c"
                                                    value={fevicyrl.art_form__c}
                                                    onChange={this.handleChange}
                                                    className="fevicyrlContent__fevicyrlMobFilters"
                                                >
                                                    <option value="">ART FORM</option>
                                                    <option
                                                        value=""
                                                        className="fevicyrlContent__filterLabel"
                                                    >
                                                        Remove Filter
                                                    </option>
                                                    {ART_FORM &&
                                                        ART_FORM.map((item) => {
                                                            return (
                                                                <>
                                                                    <option
                                                                        value={item.art_form__c}
                                                                        className="fevicyrlContent__filterLabel"
                                                                    >
                                                                        {item.art_form__c}
                                                                    </option>
                                                                </>
                                                            );
                                                        })}
                                                </Select>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="fevicyrlContent__selectMobBox">
                                                <Select
                                                    native
                                                    name="festival_generic__c"
                                                    value={fevicyrl.festival_generic__c}
                                                    onChange={this.handleChange}
                                                    className="fevicyrlContent__fevicyrlMobFilters"
                                                >
                                                    <option value="">FESTIVAL / GENERIC</option>
                                                    <option
                                                        value=""
                                                        className="fevicyrlContent__filterLabel"
                                                    >
                                                        Remove Filter
                                                    </option>
                                                    {FESTIVALGENERIC &&
                                                        FESTIVALGENERIC.map((item) => {
                                                            return (
                                                                <>
                                                                    <option
                                                                        value={
                                                                            item.festival_generic__c
                                                                        }
                                                                        className="fevicyrlContent__filterLabel"
                                                                    >
                                                                        {item.festival_generic__c}
                                                                    </option>
                                                                </>
                                                            );
                                                        })}
                                                </Select>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="fevicyrlContent__selectMobBox">
                                                <Select
                                                    native
                                                    name="is_best_out_of_waste__c"
                                                    value={fevicyrl.is_best_out_of_waste__c}
                                                    onChange={this.handleChange}
                                                    className="fevicyrlContent__fevicyrlMobFilters"
                                                >
                                                    <option value="">BEST OUT OF WASTE</option>
                                                    <option
                                                        value=""
                                                        className="fevicyrlContent__filterLabel"
                                                    >
                                                        Remove Filter
                                                    </option>
                                                    {BESTOUTOFWASTE &&
                                                        BESTOUTOFWASTE.map((item) => {
                                                            return (
                                                                <>
                                                                    <option
                                                                        value={
                                                                            item.is_best_out_of_waste__c
                                                                        }
                                                                        className="fevicyrlContent__filterLabel"
                                                                    >
                                                                        {
                                                                            item.is_best_out_of_waste__c
                                                                        }
                                                                    </option>
                                                                </>
                                                            );
                                                        })}
                                                </Select>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="fevicyrlContent__selectMobBox">
                                                <Select
                                                    native
                                                    name="year__c"
                                                    value={fevicyrl.year__c}
                                                    onChange={this.handleChange}
                                                    className="fevicyrlContent__fevicyrlMobFilters"
                                                >
                                                    <option value=""> YEARS </option>
                                                    <option value="">Remove Filter</option>
                                                    {YEARS &&
                                                        YEARS.map((item) => {
                                                            return (
                                                                <>
                                                                    <option
                                                                        value={item.year__c}
                                                                        className="fevicyrlContent__filterLabel"
                                                                    >
                                                                        {item.year__c}
                                                                    </option>
                                                                </>
                                                            );
                                                        })}
                                                </Select>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="container-fluid">
                            <div className="row fevicyrlContent__fevicyrlRow">
                                {FCC.filter((item) => {
                                    return searchTerm.toUpperCase() === ''
                                        ? item
                                        : item.name.toUpperCase().includes(searchTerm);
                                }).map((row, index) => {
                                    return (
                                        <>
                                            <div className="col-lg-2 col-md-4 col-6">
                                                <div className="fevicyrlContent__productBox">
                                                    <img
                                                        src={row.link_in_pil_tantra_url__c}
                                                        alt="ThumbnailIcon"
                                                    />
                                                    <p>{row.name}</p>
                                                    <div>
                                                        {/* <Link to={`/fevicryl-Content/${row.id}`}> */}
                                                        <IoArrowForwardCircleOutline
                                                            className="fevicyrlContent__forwardArrow"
                                                            onClick={() => this.gotoWorkshop(row)}
                                                        />
                                                        {/* </Link> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    );
                                })}
                            </div>
                        </div>
                    </>
                )}
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return { fevicyrlContent: state.fevicyrlContent.data };
};
const mapDispatchToProps = { setFevicyrlContent };

// Connect and export single default
export default connect(mapStateToProps, mapDispatchToProps)(FevicyrlContent);
